/**
 * 中文语言包
 * 默认语言
 */
export default {
  app: {
    logo: 'TikiBox',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    confirmLogout: '确定退出登录吗？',
    cancel: '取消',
    confirm: '确定',
    welcome: '欢迎',
    myOrders: '我的订单',
    myFavorites: '我的收藏',
    shoppingCart: '购物车',
    home: '首页',
    allGoods: '全部商品',
    luckyWheel: '幸运转盘',
    aboutUs: '关于我们',
    search: '请输入搜索内容',
    footer: {
      sevenDayReturn: '7天无理由退换货',
      freeShipping: '满99元全场免邮',
      qualityAssurance: '100%品质保证',
      copyright: '商城版权所有 © 2012-2026',
      slogan: '您身边的优质低价数码仓库',
      aboutColumnTitle: '关于TikoBox',
      privacy: '隐私',
      serviceRefund: '服务协议',
      infoTitle: '信息',
      refundReturnPolicy: '退款和退货政策',
      logisticsPolicy: '物流政策',
      contactUs: '联系我们',
      socialFacebook: 'Facebook',
      socialYoutube: 'YouTube'
    }
  },
  category: {
    phone: '手机',
    appliance: '家电',
    accessory: '配件',
    hot: '热门',
    tvAudio: '电视影音',
    protectiveCover: '保护套',
    charger: '充电器'
  },
  login: {
    title: '登录',
    username: '请输入账号',
    password: '请输入密码',
    button: '登录',
    usernameRule: '请输入用户名',
    usernameRuleError: '字母开头,长度5-16之间,允许字母数字下划线',
    passwordRule: '请输入密码',
    passwordRuleError: '字母开头,长度6-18之间,允许字母数字和下划线',
    success: '登录成功',
    failed: '登录失败',
    agreeRequired: '请先阅读并同意服务协议和隐私政策',
    agreePrefix: '我已阅读并同意',
    agreeAnd: '和',
    serviceAgreementLink: '《服务协议》',
    privacyPolicyLink: '《隐私政策》'
  },
  register: {
    title: '注册',
    username: '用户名',
    password: '密码',
    confirmPassword: '确认密码',
    button: '注册',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    usernameRule: '请输入用户名',
    usernameRuleError: '字母开头,长度5-16之间,允许字母数字下划线',
    passwordRule: '请输入密码',
    passwordRuleError: '字母开头,长度6-18之间,允许字母数字和下划线',
    confirmRule: '两次输入密码不一致',
    success: '注册成功',
    failed: '注册失败',
    exists: '用户名已存在'
  },
  goods: {
    all: '全部商品',
    sort: '排序',
    default: '默认',
    priceAsc: '价格从低到高',
    priceDesc: '价格从高到低',
    salesDesc: '销量从高到低',
    noResults: '未找到相关商品',
    addToCart: '加入购物车',
    addSuccess: '商品已加入购物车',
    viewDetails: '查看详情'
  },
  details: {
    addToCart: '加入购物车',
    buyNow: '立即购买',
    productDetails: '商品详情',
    specs: '规格',
    selectSpec: '请选择规格',
    stock: '库存',
    reviews: '商品评价',
    noReviews: '暂无评价',
    relatedProducts: '同类商品'
  },
  cart: {
    title: '购物车',
    empty: '购物车是空的',
    total: '合计',
    totalPrice: '总价',
    goShopping: '去购物',
    selected: '已选',
    items: '件商品',
    remove: '删除',
    clearInvalid: '清空失效商品',
    settle: '结算',
    allSelected: '全选',
    invalid: '失效',
    lineSubtotal: '小计',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败'
  },
  order: {
    title: '我的订单',
    all: '全部订单',
    pending: '待支付',
    paid: '已支付',
    shipped: '待收货',
    completed: '已完成',
    cancelled: '已取消',
    noOrders: '暂无订单',
    orderNumber: '订单号',
    orderTime: '下单时间',
    totalAmount: '合计金额',
    status: '订单状态',
    action: '操作',
    pay: '支付',
    confirmReceive: '确认收货',
    viewDetails: '查看详情'
  },
  confirmOrder: {
    title: '确认订单',
    shippingAddress: '收货地址',
    addAddress: '添加新地址',
    useDefault: '使用默认地址',
    productInfo: '商品信息',
    totalAmount: '订单总额',
    freight: '运费',
    total: '合计',
    submitOrder: '提交订单',
    payNow: '立即支付',
    orderSuccess: '订单提交成功',
    orderFailed: '订单提交失败',
    invoice: '发票信息',
    electronicInvoice: '电子发票',
    personal: '个人'
  },
  collect: {
    title: '我的收藏',
    empty: '还没有收藏商品',
    goShopping: '去逛逛',
    removeCollect: '取消收藏',
    removeSuccess: '已取消收藏'
  },
  about: {
    title: '关于我们',
    description: 'TikiBox 是一个专注于为您提供优质商品的在线商城。我们致力于为用户提供安全、便捷、优质的购物体验。'
  },
  policy: {
    returnTitle: '退换货政策',
    returnSubtitle: '退换货说明',
    returnItem1: '自签收之日起7天内，在商品完好不影响二次销售的情况下，可申请无理由退换货',
    returnItem2: '因商品质量问题（如破损、功能故障等）可申请退换货，运费由商家承担',
    returnItem3: '退换货申请需在订单详情页提交，退款将在收到商品后3-5个工作日内原路返回',
    returnItem4: '以下情况不在退换货范围内：人为损坏、定制品、个人原因导致的商品损坏',
    returnProcess: '退换货流程',
    returnProcessDesc: '提交申请 → 商家审核 → 寄回商品 → 商家收货 → 退款/换货',
    shippingTitle: '物流政策',
    shippingSubtitle: '配送说明',
    shippingItem1: '订单金额满99元，享受全场免运费服务',
    shippingItem2: '未满99元的订单，将收取相应的运费，具体费用以结算页面为准',
    shippingItem3: '支持全国大部分地区配送，偏远地区可能需要更长的配送时间',
    shippingTime: '配送时间',
    shippingTimeDesc: '正常情况下，订单将在1-3个工作日内发货，3-7个工作日内送达。具体送达时间取决于配送地址和物流情况。',
    qualityTitle: '品质保证',
    qualitySubtitle: '品质承诺',
    qualityItem1: '所有商品均为正品，经过严格的质量检验',
    qualityItem2: '商品描述真实准确，价格透明，无隐形消费',
    qualityItem3: '提供完善的售后服务，有专业的客服团队为您解决问题',
    qualityItem4: '如果您对商品质量有任何疑问，欢迎联系我们的客服团队',
    qualityService: '品质服务',
    qualityServiceDesc: '我们承诺为您提供高品质的商品和服务。如果您在购物过程中遇到任何问题，请随时联系我们的客服团队，我们将竭诚为您服务。',
    privacyTitle: '隐私政策',
    privacyItem1: '我们重视您的隐私，仅收集为完成订单与改善服务所必需的信息。',
    privacyItem2: '您的个人信息将依法受到保护，不会向无关第三方出售或泄露。',
    privacyItem3: '您可随时在账户设置中查阅或更新个人资料。',
    serviceAgreementTitle: '服务协议',
    serviceAgreementItem1: '使用本商城服务即表示您同意遵守本协议及相关规则。',
    serviceAgreementItem2: '请保证账号信息真实有效，您对账号下的行为负责。',
    serviceAgreementItem3: '商城有权在必要时更新本协议，更新后将通过网站公示。',
    serviceRefundTitle: '服务退款',
    serviceRefundItem1: '符合退换货条件的订单，退款将按原支付路径退回。',
    serviceRefundItem2: '退款处理时间一般为 3–7 个工作日，具体以支付机构为准。',
    serviceRefundItem3: '如有疑问，请联系在线客服协助处理。'
  },
  error: {
    title: '出错了',
    message: '抱歉，页面发生了错误',
    goHome: '返回首页',
    retry: '重试'
  },
  common: {
    loading: '加载中...',
    noMore: '没有更多了',
    success: '操作成功',
    failed: '操作失败',
    error: '错误',
    confirm: '确认',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    save: '保存',
    close: '关闭',
    back: '返回',
    next: '下一步',
    submit: '提交',
    price: '价格',
    quantity: '数量',
    unit: '件'
  },
  lang: {
    currentLang: '语言切换',
    switchToEn: 'English',
    switchToZh: '中文',
    switchToVi: 'Tiếng Việt'
  },
  luckyWheel: {
    title: '幸运转盘',
    start: '开始抽奖',
    startLottery: '开始抽奖',
    lotteryUsed: '今日已抽奖',
    lotteryHint: '每位用户每天限抽一次',
    lotteryUsedHint: '您今天已经抽过奖了，请明天再来',
    confirmLottery: '确定要花费50000越南盾进行抽奖吗？',
    confirmTitle: '确认抽奖',
    confirm: '确认',
    cancel: '取消',
    prizes: '奖品列表',
    rules: '活动规则',
    prize1: 'iPhone 13',
    prize2: 'AirPods Pro',
    prize3: '小米手环',
    prize4: '100元优惠券',
    prize5: '50元优惠券',
    prize6: '10元优惠券',
    congrats: '恭喜您获得',
    congratsMessage: '请及时领取您的奖品',
    rule1: '每位用户每天可参与1次抽奖',
    rule2: '中奖后请及时领取奖品',
    rule3: '优惠券有效期为7天',
    rule4: '活动最终解释权归TikiBox所有'
  }
};
